<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex :class="productionPlan.id ? 'sm6' : 'sm12'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.required('Issue date')"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.required('Issue date')"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionPlan.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No"
                  type="text"
                  readonly
                  v-model="productionPlan.issueNo"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="productionPlan.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Choose Shop..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Shop')"
                  :readonly="
                    status != 'DRAFT' || checkShopUser() ? true : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="productionPlan.warehouseId"
                  :items="warehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Warehouse')"
                  :readonly="
                    status != 'DRAFT' || checkWarehouseUser() ? true : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="productionPlan.departmentId"
                  :items="departmentList"
                  color="blue-grey lighten-2"
                  label="Choose Department..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Department')"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-select
                  v-model="productionPlan.status"
                  :items="statusList"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  :rules="rules.required('Status')"
                  :readonly="status == 'CONFIRM' || status == 'CANCEL'"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="productionPlan.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                  :readonly="status == 'CANCEL' || status == 'CONFIRM'"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="productionPlan.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionPlan.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="productionPlan.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="productionPlan.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="productionPlan.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="productionPlan.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addProductionPlanDetail()"
                    :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                  >
                    ADD ITEM
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <!-- details table -->
                <v-card>
                  <v-data-table
                    :headers="headers"
                    :items="productionPlan.productionPlanDetailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>
                        <v-text-field
                          label="Code"
                          v-model="props.item.productCode"
                          @click="
                            (showProductListDialog = !showProductListDialog),
                              (selectedId = props.item.id)
                          "
                          :disabled="
                            (status == 'PENDING' &&
                              productionPlan.id &&
                              !props.item.isNew) ||
                            status == 'CONFIRM' ||
                            status == 'CANCEL'
                          "
                          :rules="rules.codeRules"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.productName"
                          label="Name"
                          type="text"
                          readonly
                          :rules="rules.nameRules"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-autocomplete
                          v-model="props.item.factorUnitName"
                          :hide-no-data="true"
                          :items="props.item.productUnits"
                          color="blue-grey lighten-2"
                          item-value="factorUnitName"
                          item-text="factorUnitName"
                          menu-props="auto"
                          :disabled="
                            (status == 'PENDING' &&
                              productionPlan.id &&
                              !props.item.isNew) ||
                            status == 'CONFIRM' ||
                            status == 'CANCEL'
                          "
                          :rules="rules.unitRules"
                        ></v-autocomplete>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.planQty"
                          min="0"
                          type="number"
                          :rules="rules.zeroQtyRules('Plan qty')"
                          :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.productionOrderQty"
                          min="0"
                          type="number"
                          readonly
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="props.item.remark"
                          type="text"
                          :rules="rules.remarkRules"
                          :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-btn
                          icon
                          @click="remove(props.item.id)"
                          :disabled="
                            (status == 'PENDING' &&
                              productionPlan.id &&
                              !props.item.isNew) ||
                            status == 'CONFIRM' ||
                            status == 'CANCEL'
                          "
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="status == 'CONFIRM' || status == 'CANCEL'"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    @click="onSave"
                    :disabled="
                      saveLoading || status == 'CONFIRM' || status == 'CANCEL'
                    "
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!--single select product list dialog-->
    <product-list-dialog
      :showDialog="showProductListDialog"
      :params="{ status: 'ACTIVE', productType: 'PRODUCTION' }"
      @close="closeProductListDialog"
    ></product-list-dialog>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { productionPlanService } from "../../services/production-plan-service";
import { shopService } from "../../services/shop-service";
import { departmentService } from "../../services/department-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { ProductionPlan, ProductionPlanDetail } from "../../models/model";
import { ProductionPlanFormRules } from "../../helpers/validation-rules";
import ProductListDialog from "../dialogs/ProductListDialog.vue";

export default {
  name: "ProductionPlanDetail",
  components: { VSwitch, ProductListDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    messageDialogBox: false,
    showAutocompleteLoading: false,
    saveLoading: false,
    showProductListDialog: false,
    breadcrumbs: [
      {
        text: "Production Plan",
        disabled: false,
        to: "production-plans",
      },
      {
        text: "Production Plan Detail",
        disabled: true,
      },
    ],
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "PENDING", value: "PENDING" },
    ],
    headers: [
      { text: "Code", align: "left", sortable: false },
      { text: "Name", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Plan Qty", sortable: false },
      {
        text: "Production Order Qty",
        sortable: false,
      },
      { text: "Remark", sortable: false },
      { text: "Action", sortable: false },
    ],
    productionPlan: new ProductionPlan(),
    oldProductionPlan: new ProductionPlan(),
    productionPlanDetail: new ProductionPlanDetail(),
    rules: new ProductionPlanFormRules(),
    issueDate: "",
    createdDate: "",
    updatedDate: "",
    status: "DRAFT",
    responseError: "",
    activeWarehouseList: [],
    shopList: [],
    warehouseList: [],
    departmentList: [],
    selectedId: 0,
  }),
  created() {
    this.productionPlan.shopId = this.checkShopUser();
    this.productionPlan.warehouseId = this.checkWarehouseUser();
    this.getAllShopList();
    this.getActiveWarehouseList();
    this.getActiveDepartmentList();

    const id = this.$route.params.id;
    if (id == "new") {
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substring(0, 10),
        "YYYY-MM-DD"
      );
    } else {
      this.getProductionPlanDetail(id);
    }
  },
  methods: {
    checkWarehouseUser() {
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        return this.user.warehouseId;
      } else if (this.user.roleName == "PRODUCTION_MANAGER") {
        return this.user.shop.warehouseId;
      } else {
        return "";
      }
    },
    checkShopUser() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    getAllShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail = this.productionPlan.productionPlanDetailList.find(
          (d) => d.id == id
        );
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },
    addProductionPlanDetail() {
      let productionPlanDetail = JSON.parse(
        JSON.stringify(this.productionPlanDetail)
      );

      // if no id, add temporary id for key
      if (!productionPlanDetail.id) {
        productionPlanDetail.isNew = true;
        productionPlanDetail.id = this.generateId();
      }
      this.productionPlan.productionPlanDetailList.unshift(
        productionPlanDetail
      );
    },
    closeProductListDialog(product) {
      this.showProductListDialog = !this.showProductListDialog;
      if (!(JSON.stringify(product) === "{}")) {
        const index = this.productionPlan.productionPlanDetailList
          .map((d) => d.id)
          .indexOf(this.selectedId);
        this.productionPlan.productionPlanDetailList[index].productCode =
          product.code;
        this.productionPlan.productionPlanDetailList[index].productName =
          product.name;
        this.productionPlan.productionPlanDetailList[index].productUnits =
          product.productUnits;
        let basicProductUnit = product.productUnits.find(
          (v) => v.basicUnit == true
        );
        if (basicProductUnit) {
          this.productionPlan.productionPlanDetailList[index].productUnitId =
            basicProductUnit.id;
          this.productionPlan.productionPlanDetailList[index].factorUnitName =
            basicProductUnit.factorUnitName;
        }
        this.productionPlan.productionPlanDetailList[index].planQty = 0;
        this.productionPlan.productionPlanDetailList[
          index
        ].productionOrderQty = 0;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    remove(id) {
      const index = this.productionPlan.productionPlanDetailList
        .map((d) => d.id)
        .indexOf(id);

      if (!this.productionPlan.productionPlanDetailList[index].isNew) {
        // add delete stock in id
        if (!this.productionPlan.deleteProductionPlanDetailIds) {
          this.productionPlan.deleteProductionPlanDetailIds = [];
        }
        this.productionPlan.deleteProductionPlanDetailIds.push(id);
      }
      this.$delete(this.productionPlan.productionPlanDetailList, index);
    },
    getProductionPlanDetail(id) {
      productionPlanService
        .getProductionPlanDetail(id)
        .then((res) => {
          this.productionPlan = res.data;
          this.issueDate = commonService.millisecondToDate(
            this.productionPlan.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.createdDate = commonService.millisecondToDate(
            this.productionPlan.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.productionPlan.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.status = this.productionPlan.status;
          if (this.status == "DRAFT") {
            this.statusList = [
              { label: "DRAFT", value: "DRAFT" },
              { label: "PENDING", value: "PENDING" },
              { label: "CANCEL", value: "CANCEL" },
            ];
          } else if (this.status == "PENDING") {
            this.statusList = [
              { label: "PENDING", value: "PENDING" },
              { label: "CONFIRM", value: "CONFIRM" },
            ];
          } else {
            this.statusList = [
              { label: "CANCEL", value: "CANCEL" },
              { label: "CONFIRM", value: "CONFIRM" },
            ];
          }
          if (this.productionPlan.warehouse) {
            this.warehouseList.push(this.productionPlan.warehouse);
          }
          if (this.productionPlan.department) {
            this.departmentList.push(this.productionPlan.department);
          }
          this.oldProductionPlan = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          let productionPlanObj = this.productionPlan;
          productionPlanObj.issueDateInMilliSeconds =
            commonService.convertToMilliseconds(this.issueDate);
          productionPlanObj.productionPlanDetailList.forEach((detail) => {
            if (detail.isNew) detail.id = null;
          });
          productionPlanService
            .saveProductionPlan(productionPlanObj)
            .then((res) => {
              if (res) {
                this.goBack();
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.productionPlan.id) {
        this.productionPlan = new ProductionPlan();
        this.addProductionPlanDetail();
      } else {
        this.productionPlan = Object.assign({}, this.oldProductionPlan);
      }
    },
  },
};
</script>
